exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.frhomolo-video-wrapper .weui-dialog__hd {\r\n  padding: 0;\n}\r\n", ""]);

// exports
